export function useCustomFetch(url, options = {}) {
  const runtimeConfig = useRuntimeConfig()
  const selectedCountry = useState('countrySelected')
  const selectedLanguage = useCookie('selected-language')
  const defaults = {
    baseURL: runtimeConfig.public.API_URL,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Api-Origin': runtimeConfig.public.API_ORIGIN,
      Accept: 'application/json',
      'Country-Code': selectedCountry,
      'Lang-Code': selectedLanguage.value,
      ...options
    }
  }

  return useFetch(url, {
    ...defaults,
    ...options
  })
}
